import React from "react";
import { HelpCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const FAQSection = ({ faqs, title, subtitle }) => {
  return (
    <section className="py-16 sm:py-20 bg-slate-50">
      <div className="container-app max-w-4xl">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 text-sky-600 font-semibold text-sm bg-sky-50 px-4 py-1.5 rounded-full">
            <HelpCircle size={16} /> FAQs
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mt-4">
            {title || "Frequently Asked Questions"}
          </h2>
          {subtitle && <p className="text-slate-500 mt-3">{subtitle}</p>}
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="bg-white border border-slate-200 rounded-xl px-5 shadow-sm">
              <AccordionTrigger className="text-left font-heading font-semibold text-slate-800 hover:no-underline hover:text-sky-600 py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
